<template>
  <div>
    <v-container>
      <h1>Email Format</h1>
      <!-- <quill-editor v-model="content" :options="editorOption"></quill-editor> -->
      <v-tabs>
        <v-tab class="text-none">Individual Personnel Movement</v-tab>
        <v-tab class="text-none">Batch Personnel Movement</v-tab>
        <v-tab class="text-none">Other Notification</v-tab>

        <v-tab-item>
          <v-card flat>
            <v-card-text>
              <individual></individual>
            </v-card-text>
          </v-card>
        </v-tab-item>
        <v-tab-item>
          <v-card flat>
            <v-card-text>
              <batch></batch>
            </v-card-text>
          </v-card>
        </v-tab-item>
        <v-tab-item>
          <v-card flat>
            <v-card-text>
              <other-notif></other-notif>
            </v-card-text>
          </v-card>
        </v-tab-item>
      </v-tabs>
    </v-container>
  </div>
</template>
<script>
import Individual from "./Individual";
import Batch from "./Batch";
import OtherNotif from "./OtherNotif.vue";
export default {
  metaInfo: {
    title: "Email Format",
    titleTemplate: `%s - ${process.env.VUE_APP_NAME}`,
  },
  components: {
    Individual,
    Batch,
    OtherNotif,
  },
  data: () => ({}),
};
</script>
